/* eslint-disable camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composerasdfsad
 */
import {
  withLayout,
  withLayoutAccordion,
  
} from '@thd-olt-component-react/fusion-utils';


  import {
    PipProductError as PipProductError_MiddlewareSlot
  } from '@thd-olt-component-middleware/fourxx-middleware';

  import {
    DisplayOnCustomer as DisplayOnCustomer_MiddlewareSlot
  } from '@thd-olt-component-middleware/fourxx-middleware';






  import { ProductErrorB2B }
    from "@thd-olt-component-react/error-components";
  
  export { ProductErrorB2B }

  import { ProductErrorB2C }
    from "@thd-olt-component-react/error-components";
  
  export { ProductErrorB2C }

  import { DynamicRecsWrapper }
    from "@thd-olt-component-react/thd-recs-containers";
  
  export { DynamicRecsWrapper }



  
    
      
        let PipProductError_MiddlewareSlot_A1 = PipProductError_MiddlewareSlot;
        
      
        const SlotA1 = withLayout(
          [
            
              ProductErrorB2B,
            
              ProductErrorB2C,
            
          ],
          
            PipProductError_MiddlewareSlot_A1
          
        );
      
    
  

  
    
      
        let DisplayOnCustomer_MiddlewareSlot_A2 = DisplayOnCustomer_MiddlewareSlot;
        
      
        const SlotA2 = withLayout(
          [
            
              DynamicRecsWrapper,
            
          ],
          
            DisplayOnCustomer_MiddlewareSlot_A2
          
        );
      
    
  



const ssr = typeof window === 'undefined';


  
  

  
  



export {
  
  
    
      SlotA1,
    
  
    
      SlotA2,
    
  

  
  
    
  
    
  

};
